import React from "react";
import { AnalyticsCard } from "../../../../../Components/Cards";

interface ChannelItem {
  name: string;
  value: number;
  percent: string;
}

interface ChannelBreakdownCardProps {
  readonly title: string;
  readonly total: number;
  readonly channels: ChannelItem[];
  readonly icon: React.ReactNode;
  readonly iconBgColor: string;
  readonly iconColor: string;
}

export function ChannelBreakdownCard(props: ChannelBreakdownCardProps) {
  const { title, total, channels, icon, iconBgColor, iconColor } = props;

  return (
    <AnalyticsCard
      title={title}
      type="metrics"
      metricsData={{ total, channels, icon, iconBgColor, iconColor }}
    />
  );
}
